<template>
  <div>
    <b-sidebar
      id="sidebar-job-sample-settings"
      sidebar-class="sidebar-lg"
      :visible="jobSampleSettingsSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => mutateJobSampleSettingsSidebar({ visible: val })"
      @hidden="clear"
      @shown="onShow"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h4>Configurações do Job Sample</h4>
          <div>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="onSubmit"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col cols="12" md="12" class="mb-1">
              <small>A data, a plataforma e o link informados serão adicionados no e-mail de Job Sample enviado para os candidatos</small>
            </b-col>
            <b-col cols="12" md="12" class="mb-1">
              <b-form-group
                label="Data do Job Sample"
                label-for="jobSampleDate"
              >
                <b-form-input
                  id="jobSampleDate"
                  v-model="jobSampleDate"
                  :class="{
                    'is-invalid': v$.jobSampleDate.$error,
                  }"
                  placeholder="24/03 e 26/03, às 19h"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="mb-1">
              <b-form-group
                label="Plataforma da reunião"
                label-for="jobSamplePlatform"
              >
                <v-select
                  id="jobSamplePlatform"
                  v-model="jobSamplePlatform"
                  :reduce="(platform) => platform.id"
                  :options="jobSamplePlatformTypes"
                  :loading="loading"
                  label="description"
                >
                  <template #no-options="{ search, searching, loading }">
                    Sem resultados
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="mb-1">
              <b-form-group
                label="Link da reunião"
                label-for="jobSampleLink"
              >
                <b-form-input
                  id="jobSampleLink"
                  v-model="jobSampleLink"
                  :class="{
                    'is-invalid': v$.jobSampleLink.$error,
                  }"
                  placeholder="https://meet.google.com/abc-defg-hij"
                />
                <div class="invalid-feedback">
                  <span v-if="v$.jobSampleLink.validUrl.$invalid">
                    Você deve informar uma URL válida
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <div class="sidebar-bottom px-1">
              <b-col cols="12" md="6" class="mt-2 sidebar-bottom-button">
                <b-button
                  variant="outline-primary"
                  @click="hide"
                  > Fechar
                </b-button>
              </b-col>
              <b-col cols="12" md="6" class="mt-2 sidebar-bottom-button">
                <b-button
                 :disabled="saving"
                  variant="primary"
                  type="submit"
                >  
                  {{ saving ? 'Salvando...' : 'Salvar' }}
                </b-button>
              </b-col>
            </div>
          </b-row>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import vSelect from 'vue-select'
import * as types from '../store/types'
import FileChooser from '@/modules/shared/components/FileChooser.vue'

export default {
  components: {
    FileChooser,
    vSelect
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      saving: false,
      loading: false,
      jobSampleDate: undefined,
      jobSamplePlatform: undefined,
      jobSampleLink: undefined
    }
  },
  computed: {
    ...mapGetters({
      jobSampleSettingsSidebar: types.JOB_SAMPLE_SETTINGS_SIDEBAR,
      jobSamplePlatformTypes: types.JOB_SAMPLE_PLATFORM_TYPES
    })
  },
  setup() {
    return { toast: useToast(), v$: useVuelidate() };
  },
  validations(){
    return {
      jobSampleDate: { required },
      jobSamplePlatform: {},
      jobSampleLink: {
        validUrl(value) {
          if (!value) return true;
          try {
            const urlPattern = /^(https?:\/\/)?(www\.)?([a-z0-9]+([.-][a-z0-9]+)*\.)([a-z]{2,}|[a-z]{2,}\.[a-z]{2,})(:[0-9]{1,5})?(\/.*)?$/i;
            return urlPattern.test(value);
          } catch {
            return false;
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      mutateJobSampleSettingsSidebar: types.MUTATE_JOB_SAMPLE_SETTINGS_SIDEBAR
    }),
    ...mapActions({
      getActiveRecruitment: types.GET_ACTIVE_RECRUITMENT,
      getJobSamplePlatformTypes: types.GET_JOB_SAMPLE_PLATFORM_TYPES,
      updateJobSampleDate: types.UPDATE_JOB_SAMPLE_DATE
    }),
    onShow() {
      this.loading = true;
      this.getJobSamplePlatformTypes().catch(() => {});
      this.getActiveRecruitment()
        .then(response => {
          const recruitment = response.data || {}
          this.jobSampleDate = recruitment.job_sample_date
          this.jobSamplePlatform = recruitment.job_sample_platform
          this.jobSampleLink = recruitment.job_sample_link
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clear(){
      this.jobSampleDate = undefined
      this.jobSamplePlatform = undefined
      this.jobSampleLink = undefined
      this.v$.$reset();
    },
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return
      this.saving = true
      this.updateJobSampleDate({
          job_sample_date: this.jobSampleDate,
          job_sample_platform: this.jobSamplePlatform,
          job_sample_link: this.jobSampleLink
      })
        .then(response => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Sucesso",
                text: "As configurações foram atualizadas!",
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
            this.mutateJobSampleSettingsSidebar({visible: false})
          })
        .catch((err) => {
          if(err.response.status == 405){
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: err.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }else{
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao salvar as configurações. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.sidebar-bottom {
  position: absolute;
  bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .sidebar-bottom-button {
    button {
      display: flex;
      border-radius: 10px;
      height: 38px;
      align-items: center;
      justify-content: center;
      width: 170px;
      font-size: 14px;
    }
  }
}
</style>
